// Import necessary functions from Vue Router
import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

// Import view components for different routes
import HomeView from "@/views/HomeView.vue";
import CategoryView from "@/views/CategoryView.vue";
import AboutView from "@/views/aboutView.vue";
import Register from "@/views/register.vue";
import { apiDataService } from "@/services/apiDataService";
import EventView from "@/views/event/EventView.vue";
import AdminLayout from "@/AdminLayout.vue";
import EventList from "@/views/event/EventListView.vue";
import EventEdit from "@/views/event/EventEdit.vue";
import IndexView from "@/views/organizer/IndexView.vue";
import EventAnalytics from "@/views/event/EventAnalytics.vue";
import AddUserView from "@/views/user/addUserView.vue";
import UserListView from "@/views/user/UsersListView.vue";
import CreateOrganization from "@/views/organizer/CreateOrganization.vue";
import MarketingView from "@/views/marketing/MarketingView.vue";
import RevenueView from "@/views/revenue/RevenueView.vue";
import BetaApp from "@/views/betaView/betaApp.vue";
import AttendeeList from "@/views/event/AttendeeList.vue";

// Define the routes configuration
const routes = [
	// Home route: loads the HomeView component

	// Order management route: loads the OrderView component
	{
		path: "/admin",
		component: AdminLayout,
		children: [
			{
				path: "dashboard",
				name: "Home", // Route name
				component: HomeView, // Component to be displayed for this route
				meta: {
					requiresAuth: true,
					adminOnly: false,
					breadcrumb: [{ label: "Dashboard", path: "/admin/dashboard" }],
				},
			},
			{
				path: "dashboard/event/:eventId",
				name: "EventAnalytics", // Route name
				component: EventAnalytics,
				meta: {
					requiresAuth: true,
					adminOnly: false,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Events", path: "/admin/event/all" },
						{ label: "Event Analytics", path: "" },
					],
				},
			},
			{
				path: "event",
				name: "EventManagment",
				component: EventView,
				meta: {
					requiresAuth: true,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Events", path: "/admin/event/all" },
						{ label: "Create Events", path: "/admin/event" },
					],
				},
			},
			{
				path: "event/all",
				name: "eventList",
				component: EventList,
				meta: {
					requiresAuth: true,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Events", path: "/admin/event/all" },
					],
				},
			},
			{
				path: "event/edit/:id",
				name: "EventDetail",
				component: EventEdit,
				meta: {
					requiresAuth: true,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Events", path: "/admin/event/all" },
						{ label: "Edit Event", path: "" },
					],
				},
			},
			// Attendee list route for a specific event
			{
				path: "event/attendee/:id",
				name: "AttendeeList", // Route name
				component: AttendeeList, // Component to be displayed for this route
				meta: {
					requiresAuth: true,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Events", path: "/admin/event/all" },
						{ label: "Attendees", path: "" },
					],
				},
			},
			{
				path: "category",
				name: "CategoryManagement", // Route name
				component: CategoryView, // Component to be displayed for this route
				meta: {
					requiresAuth: true,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Categories", path: "/admin/category" },
					],
				},
			},
			{
				path: "organization",
				name: "CreateOrganization", // Route name
				component: CreateOrganization, // Component to be displayed for this route
				meta: {
					requiresAuth: true,
					adminOnly: false,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Organizations", path: "/admin/organization/all" },
						{ label: "Create Organizations", path: "/admin/organization" },
					],
				},
			},
			{
				path: "organization/all",
				name: "OrganizationList", // Route name
				component: IndexView, // Component to be displayed for this route
				meta: {
					requiresAuth: true,
					adminOnly: false,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Organizations", path: "/admin/organization/all" },
					],
				},
			},
			{
				path: "user",
				name: "UserManagement", // Route name
				component: AddUserView,
				meta: {
					requiresAuth: true,
					adminOnly: false,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Users", path: "/admin/user/all" },
						{ label: "Add User", path: "/admin/user" },
					],
				},
			},
			{
				path: "user/all",
				name: "userList", // Route name
				component: UserListView,
				meta: {
					requiresAuth: true,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Users", path: "/admin/user/all" },
					],
				},
			},
			{
				path: "marketing",
				name: "MarketingView", // Route name
				component: MarketingView,
				meta: {
					requiresAuth: true,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Growth & Outreach", path: "/admin/marketing" },
					],
				},
			},
			{
				path: "revenue",
				name: "RevenueView", // Route name
				component: RevenueView,
				meta: {
					requiresAuth: true,
					adminOnly: false,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Revenue", path: "/admin/revenue" },
					],
				},
			},
			{
				path: "download",
				name: "betaApp", // Route name
				component: BetaApp,
				meta: {
					requiresAuth: true,
					breadcrumb: [
						{ label: "Dashboard", path: "/admin/dashboard" },
						{ label: "Download", path: "/admin/download" },
					],
				},
			},
		],
	},

	{
		path: "/register",
		name: "registerClient", // Route name
		component: Register, // Component to be displayed for this route
		props: true, // Pass route parameters as props to the component
	},
	{
		path: "/",
		name: "about-us",
		component: AboutView,
	},
	// {
	// 	path: "/ticket/:ticketCode", // This should match the URL with a dynamic parameter
	// 	name: "view-ticket",
	// 	component: TicketManagement, // The component that handles the ticket code
	// 	meta: { requiresAuth: true },
	// 	props: true, // Pass the ticketCode as a prop to the component
	// },
	{
		path: "/:catchAll(.*)", // catches anything not matched above
		name: "NotFound",
		component: () => import("@/views/NotFoundView.vue"), // or any 404 page
	},
];

// Create the Vue Router instance with history mode and the defined routes
const router = createRouter({
	history: createWebHistory(process.env.BASE_URL), // Use web history mode for clean URLs
	routes, // Register routes
});
router.beforeEach(async (to, from, next) => {
	try {
		const isAuthenticated = await apiDataService.checkAuth();
		const user = store.state.auth.user;
		if (!user && to.meta.requiresAuth) {
			return next("/register");
		}
		const userRole = store.state.auth.user?.data?.user_type;
		if (isAuthenticated && to.path === "/register") {
			return next("/admin/dashboard");
		}

		if (!isAuthenticated && to.meta.requiresAuth) {
			return next("/register");
		}
		if (to.meta.adminOnly && userRole !== 0) {
			return next("/unauthorized"); // Or any safe fallback route
		}

		return next();
	} catch (error) {
		console.error("Auth check failed:", error);
		if (to.meta.requiresAuth) return next("/register");
		return next();
	}
});

// Export the router for use in the main Vue app
export default router;
